export const Images = {
    kasperskyWallpaper: "/background.jpg",
    forgotPassword: "/forgot-password.svg",
    placeholder: "/placeholder.jpg",
    categories: "/categories.jpg",
    latestProducts: "/latest-products.webp",
    featuredProducts: "/featured-products.webp",
    wishlist: "/wishlist.jpg",
    connectionLost: "/404.svg",
}